import { alias } from '@ember/object/computed';
import Controller from '@ember/controller';
import { computed, get } from '@ember/object';

export default Controller.extend({
  goal: alias('model.dashboard.goal'),

  ytdTotalAmount: computed(
    'goal.goalData.{annual_pledged_amount,annual_other_amount}',
    function () {
      return (
        +get(this, 'goal.goalData.annual_pledged_amount') +
        +get(this, 'goal.goalData.annual_other_amount')
      );
    },
  ),

  lastMonthTotalAmount: computed(
    'goal.goalData.{last_month_pledged_amount,last_month_other_amount}',
    function () {
      return (
        +get(this, 'goal.goalData.last_month_pledged_amount') +
        +get(this, 'goal.goalData.last_month_other_amount')
      );
    },
  ),

  lastMonthGoalAmount: computed('goal.goalAmount', function () {
    return +get(this, 'goal.goalAmount') / 12;
  }),
});
